var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"px-6"},[_c('v-container',{staticClass:"px-1"},[_c('div',{staticClass:"d-flex justify-end align-center"},[_c('LanguageSwitcher',{on:{"languageChanged":function($event){return _vm.$emit('languageChanged')}}})],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }